<div id="confirm-dialog">
  <div class="header">
    <i class="pi pi-exclamation-circle icon"></i>
    <h4>
      {{ "slot_management.attention" | translate }}
    </h4>
  </div>
  <div class="body">
    @switch (flag) { @case ('edit_slot') {
    <div class="text">
      {{ "slot_management.edit_slot_warning" | translate }}
    </div>
    } @default {
    <div class="text">
      {{ "slot_management.are_you_sure" | translate }}
    </div>
    } }
  </div>
  <div class="buttons">
    <p-button
      (onClick)="Close(false)"
      severity="secondary"
      label="{{ 'no' | translate }}"
    ></p-button>
    <p-button (onClick)="Close(true)" label="{{ 'yes' | translate }}"></p-button>
  </div>
</div>
